import 'twin.macro';
import React from 'react';
import ButtonRadio from '@teetsh/app/src/components/Form/ButtonsRadio';
import { NumberNote } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/components/NumberNote';
import { useCDNContext } from '@teetsh/app/src/containers/CarnetsDeNotes/CarnetDeNotesContext';
import { Note } from 'containers/CarnetsDeNotes/types/carnetsDeNotes';

interface Props {
  value?: Note;
  onChange: (v: number) => void;
  onKeyPress?: (e: any) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  'aria-label'?: string;
}

export function SingleNote(props: Props) {
  const { value, onChange, inputRef, onKeyPress } = props;
  const { notationSystem } = useCDNContext();
  const noteValue =
    value?.note === undefined
      ? ''
      : notationSystem.getClosestValueFromNotationSystem(value?.note);
  if (notationSystem.type === 'competency') {
    return (
      <div tw="flex flex-wrap">
        <ButtonRadio
          withoutMargin
          small
          value={noteValue}
          canBeEmpty
          onChange={onChange}
          options={notationSystem.values.map(v => ({
            label: v.label,
            value: v.value,
            tooltip: v.tooltip,
            color: notationSystem.getNoteColorContrast(v.value),
          }))}
        />
      </div>
    );
  }

  return (
    <NumberNote
      small
      notationSystem={notationSystem}
      aria-label={props['aria-label']}
      onChange={onChange}
      inputRef={inputRef}
      onKeyPress={onKeyPress}
      value={value}
    />
  );
}
